import React from "react";
import { Trans } from "react-i18next";

import TicketTag from "../UserInfo/TicketTag";
import CreditCardTag from "../UserInfo/CreditCardTag";
import SubscriberTag from "../UserInfo/SubscriberTag";

export default function TagIdTitre(props) {
  let userInfo = null;
  switch (props.idtitre.substr(0, 1)) {
    case "0":
      userInfo = <TicketTag id={props.idtitre.substr(1)} />;
      // ticket id should be formatted like 06220220930190929
      break;
    case "1":
      userInfo = <CreditCardTag id={props.idtitre.substr(1)} />;
      break;
    case "2":
      userInfo = <SubscriberTag id={props.idtitre.substr(1)} />;
      break;
    case "4":
      if (props.idtitre.substr(1, 1) === "3")
        userInfo = <Trans>manual opening</Trans>;
      else
        userInfo = <span><Trans>unknownType</Trans> {props.idtitre}</span>;
      break;
    case "5":
      userInfo = <span><Trans>booking</Trans> {props.idtitre}</span>;
      break;
    default:
      userInfo = <span><Trans>unknownType</Trans> {props.idtitre}</span>;
      break;
  }
  return <div><Trans>parking:</Trans> {userInfo}</div>;
}